<!--<template>
    <div id="bottomLeft">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2">
                <span style="color:#5cd9e8">
                  <icon name="chart-bar"></icon>
                </span>
                <div class="d-flex">
                    <span class="fs-xl text mx-2">设备报警排行</span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />

                </div>
            </div>
            <div v-if="bar1_data.x.length > 0">
                <div id="bar1" style="width:3rem;height:2.8rem;margin-top: 25px"></div>

            </div>
            <div v-else>
                <div style="margin: 20px">暂无报警设备</div>
            </div>
        </div>
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";
  export default {
    data() {
      return {
        chart: null
      };
    },
    mixins: [echartMixins],
    props: {
      bar1_data: {
        type: Object
      }
    },
    mounted() {
      this.draw();
    },
    methods: {
      draw() {
        // 基于准备好的dom，初始化echarts实例
        this.chart = this.$echarts.init(document.getElementById("bar1"));

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              label: {
                show: true
              }
            }
          },
          calculable: true,
          legend: {
            data: ['异常数'],
            itemGap: 5
          },
          grid: {
            top: '12%',
            left: '1%',
            right: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: this.bar1_data.x,
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#fff'
                }
              }

            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '报警数',
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#fff'
                }
              }
            }
          ],
          // dataZoom: [
          //   {
          //     show: true,
          //     start: 0,
          //     end: 100
          //   },
          //   {
          //     type: 'inside',
          //     start: 0,
          //     end: 100
          //   },
          //   {
          //     show: true,
          //     yAxisIndex: 0,
          //     filterMode: 'empty',
          //     width: 30,
          //     height: '50%',
          //     showDataShadow: false,
          //     left: '93%'
          //   }
          // ],
          series: this.bar1_data.series
        };


        this.chart.setOption(option);
      }
    },
    destroyed() {
      window.onresize = null;
    }
  };
</script>

<style lang="scss">
    #bottomLeft {
        padding: 0.3rem 0.2rem;
        height: 3.5rem;
        min-width: 1.75rem;
        border-radius: 0.0625rem;
        .bg-color-black {
            height: 3rem;
            border-radius: 0.125rem;
        }
        .text {
            color: #c3cbde;
        }
        .chart-box {
            margin-top: 0.2rem;
            width: 1.125rem;
            height: 2.125rem;
            .active-ring-name {
                padding-top: 0.125rem;
            }
        }
    }
</style>
-->
<template>
    <div id="bottomLeft">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2">
                <span style="color:#5cd9e8">
                  <icon name="chart-bar"></icon>
                </span>
                <div class="d-flex" v-if="cn" >
                    <span class="fs-xl text mx-2">报警传感器</span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />

                </div>
                <div class="d-flex" v-else>
                    <span class="fs-xl text mx-2">报警设备</span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />

                </div>
            </div>
            <div class="d-flex jc-center body-box">
                <dv-scroll-board :config="config" style="width:5.5rem;height:2.2rem;" />
            </div>
        </div>
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";
  export default {
    props: {
      config: {
        type: Object
      },cn:{type:Number}},
    mixins: [echartMixins],
  };
</script>

<style lang="scss">
    #bottomLeft {
        padding: 0.3rem 0.2rem;
        height: 3.5rem;
        min-width: 1.75rem;
        border-radius: 0.0625rem;
        .bg-color-black {
            height: 3rem;
            border-radius: 0.125rem;
        }
        .text {
            color: #c3cbde;
        }
        .chart-box {
            margin-top: 0.2rem;
            width: 1.125rem;
            height: 2.125rem;
            .active-ring-name {
                padding-top: 0.125rem;
            }
        }
    }
</style>
